<app-header [compact]="true" />

<div class="content">

    <div class="page-header">
        <h1 class="page-title">Eliminar cuenta</h1>
        <p class="page-subtitle">
            Puedes eliminar tu cuenta de BarBook en cualquier momento directamente desde la aplicación.
        </p>
    </div>

    <div class="section">
        <div class="section-title">Cómo eliminar tu cuenta</div>

        <div class="steps">

            <div class="step">
                <div class="step-number">1</div>
                <div class="step-body">
                    <strong>Abre la aplicación BarBook</strong>
                    <span>Inicia sesión si aún no lo has hecho.</span>
                </div>
            </div>

            <div class="step">
                <div class="step-number">2</div>
                <div class="step-body">
                    <strong>Ve a la pantalla de inicio</strong>
                    <span>Asegúrate de estar en la pantalla principal (Home) de la aplicación.</span>
                </div>
            </div>

            <div class="step">
                <div class="step-number">3</div>
                <div class="step-body">
                    <strong>Abre el menú de opciones</strong>
                    <span>Pulsa el icono de tres puntos (⋮) en la esquina superior derecha de la pantalla.</span>
                </div>
            </div>

            <div class="step">
                <div class="step-number">4</div>
                <div class="step-body">
                    <strong>Accede a Configuración</strong>
                    <span>Selecciona la opción <em>Configuración</em> en el menú desplegable.</span>
                </div>
            </div>

            <div class="step">
                <div class="step-number">5</div>
                <div class="step-body">
                    <strong>Selecciona "Eliminar cuenta"</strong>
                    <span>Encontrarás esta opción al final de la pantalla de configuración.</span>
                </div>
            </div>

            <div class="step">
                <div class="step-number">6</div>
                <div class="step-body">
                    <strong>Confirma la eliminación</strong>
                    <span>Lee el aviso y confirma. Tu cuenta y todos tus datos serán eliminados de forma permanente.</span>
                </div>
            </div>

        </div>
    </div>

    <div class="warning">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
            <line x1="12" y1="9" x2="12" y2="13"/>
            <line x1="12" y1="17" x2="12.01" y2="17"/>
        </svg>
        <div class="warning-body">
            <strong>Acción irreversible</strong>
            <span>La eliminación de tu cuenta es permanente. Se borrarán tu perfil, listas, notas y todos los datos asociados y no podrán recuperarse.</span>
        </div>
    </div>

    <div class="section support">
        <div class="section-title">¿Necesitas ayuda?</div>
        <p class="support-text">
            Si tienes problemas para eliminar tu cuenta o necesitas asistencia, escríbenos y te ayudaremos lo antes posible.
        </p>
        <a href="mailto:support@barbook.es" class="support-link">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="2" y="4" width="20" height="16" rx="2"/>
                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
            </svg>
            support&#64;barbook.es
        </a>
    </div>

</div>
